import { DeleteOutlined, MailOutlined, PlusOutlined } from '@ant-design/icons'
import { Button, Input, List, message, Radio } from 'antd'
import React, { useState } from 'react'
import useUpdateCustomerSettings from '../../../Utils/useUpdateCustomerSettings';

const EmailsList = ({ payload, isLoading, item }) => {

  const [isAddingEmail, setIsAddingEmail] = useState(false);
  const [newEmail, setNewEmail] = useState('');
  const [showEmails, setShowEmails] = useState(false);

  const updateCustomerSettings = useUpdateCustomerSettings();

    const handleSaveParams = (value, data, customerId) => {
      updateCustomerSettings(value, data, customerId);
    }

   const handleAddEmailClick = () => {
      setIsAddingEmail(true);
    };
  
    const handleEmailChange = (e) => {
      setNewEmail(e.target.value);
    };
  
    const handleEmailSubmit = () => {
      if (newEmail.trim()) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic email validation
        if (!emailRegex.test(newEmail.trim())) {
          message.error('Please enter a valid email address');
          return;
        }
    
        const updatedEmails = [...(item.invoiceParams.orderEmail || []), newEmail.trim()];
        updateCustomerSettings({ orderEmail: updatedEmails }, item?.invoiceParams);
    
        setNewEmail('');
        setIsAddingEmail(false);
      }
    };
  
    const handleDeleteEmail = (email) => {
      if (!item.invoiceParams.orderEmail) return;
    
      let updatedEmails = item.invoiceParams.orderEmail.filter(e => e !== email);
    
      // console.log(`UPDATED: ${updatedEmails}`);
      updateCustomerSettings({ orderEmail: updatedEmails }, item?.invoiceParams);
    };

    console.log(`IS ADDING EMAIL: ${isAddingEmail}`)


    const isOverflow = item?.invoiceParams?.orderEmail?.length > 2
    const emails = showEmails ? item?.invoiceParams?.orderEmail : item?.invoiceParams?.orderEmail?.slice(0, 2)


  return (
  <>
    <Radio.Group
                block
                options={[
                  { label: 'PRE PAY', value: 'PRE_PAY' },
                  { label: 'POST PAY', value: 'POST_PAY' },]}
                defaultValue={item?.invoiceParams?.sendOrderMode !== null ? item?.invoiceParams?.sendOrderMode : null}
                optionType="button"
                buttonStyle="solid"
                onChange={(e) => handleSaveParams({ sendOrderMode: e.target.value }, item?.invoiceParams, item?.id)}
              />

    <List
      className='settings_emails_container'
      loading={isLoading}
      header={<p><MailOutlined /> Customer emails  <Button className="settings_emails_addBtn" icon={<PlusOutlined />} onClick={handleAddEmailClick}>
              </Button></p>} 
                bordered
                dataSource={[...(emails || []), ...(isAddingEmail ? [''] : [])]}
                renderItem={(it, index) => (
                  <List.Item className='company_item'>
                    {isAddingEmail && index === emails?.length ? (
                      <Input
                        value={newEmail}
                        onChange={handleEmailChange}
                        onPressEnter={handleEmailSubmit}
                        onBlur={() => setIsAddingEmail(false)}
                        placeholder="Enter email"
                      />
                    ) : (
                      <div className='settings_input_wrapper'>
                        <Input
                        value={it}
                        onChange={handleEmailChange}
                        onPressEnter={handleEmailSubmit}
                        onBlur={() => setIsAddingEmail(false)}
                        placeholder="Enter email"
                      />
                        {/* {item}  */}
                        <Button className="delete_btn" onClick={() => handleDeleteEmail(it)} icon={<DeleteOutlined />} />
                      </div>
                    )}
                  </List.Item>
                )}
              />

              {isOverflow && <Button onClick={() => setShowEmails(prev => !prev)}>View {showEmails ? "less" : "all"}</Button>}
              </>
  )
}

export default EmailsList
